import { TweenLite, TimelineLite, CSSRulePlugin, Power4 } from 'gsap';

function Animation() {
    this.timeLine = new TimelineLite();
}

Animation.prototype.base = function baseAnimation() {
    this.timeLine.to('.service__header div[class*="col-"]', 2, {
        y: 0,
        opacity: 1,
        ease: Power4.easeOut,
    }).delay(.25);
}

Animation.prototype.app = function appAnimation() {
    this.timeLine.to('.animation__inner img:last-child', 2, {
        y: 0,
        ease: Power4.easeOut,
    }, '-=2').to('.animation__inner img:first-child', 2, {
        y: 125,
        ease: Power4.easeOut,
    }, '-=1.75');
}

function serviceHeaderAnimation() {
    const animationContainer = document.querySelector('.header__animation');

    const animation = new Animation();
    animation.base();

    if (!animationContainer) {
        return false;
    }

    const animationType = /--([a-zA-Z]+)/g.exec(animationContainer.className)[1];
    if (!animationType) {
        return false;
    }

    animation[animationType]();
}

export default serviceHeaderAnimation;